import API from "../../../../../../global/api";

//Post Data from 1 to 18 Questions

export const postData = (data) => {
  return (dispatch) => {
    API.put(`/form_160_assets/add-and-update-form-160-asset`, data).then((res) => {
      let dataPost = res.data;
      console.log(dataPost, "datapost")


      if (dataPost.data[0].asset_brief_description_id == 1) {
        dispatch(successRealEstate(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 2) {
        dispatch(successHouseHold(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 3) {
        dispatch(successJewelary(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 4) {
        dispatch(successVehicles(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 5) {
        dispatch(successSavings(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 6) {
        dispatch(successChecking(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 7) {
        dispatch(successCredit(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 8) {
        dispatch(successCash(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 9) {
        dispatch(successTaxRefund(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 10) {
        dispatch(successLifeInsurance(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 11) {
        dispatch(successStocks(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 12) {
        dispatch(successRetirements(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 13) {
        dispatch(successProfit(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 14) {
        dispatch(successAccounts(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 15) {
        dispatch(successPartnership(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 16) {
        dispatch(successOtherAssets(dataPost));
      }

    });
  };
};



//Action

export const requestpostCommunityProperty = (data) => {
  return {
    type: "REQUEST_POST_COMMUNITY_PROPERTY",
  };
};
export const successpostCommunityProperty = (data) => {
  return {
    type: "SUCCESS_POST_COMMUNITY_PROPERTY",
    payload: data,
  };
};
export const errorpostCommunityProperty = (data) => {
  return {
    type: "ERROR_POST_COMMUNITY_PROPERTY",
    payload: data,
  };
};

//Real Estate Action

export const requestRealEstate = (data) => {
  return {
    type: "REQUEST_REAL_ESTATE",
  };
};
export const successRealEstate = (data) => {
  return {
    type: "SUCCESS_REAL_ESTATE",
    payload: data,
  };
};
export const errorRealEstate = (data) => {
  return {
    type: "ERROR_REAL_ESTATE",
    payload: data,
  };
};

//House Hold Action

export const requestHouseHold = (data) => {
  return {
    type: "REQUEST_HOUSE_HOLD",
  };
};
export const successHouseHold = (data) => {
  return {
    type: "SUCCESS_HOUSE_HOLD",
    payload: data,
  };
};
export const errorHouseHold = (data) => {
  return {
    type: "ERROR_HOUSE_HOLD",
    payload: data,
  };
};

//Jewelary Action

export const requestJewelary = (data) => {
  return {
    type: "REQUEST_JEWELARY",
  };
};
export const successJewelary = (data) => {
  return {
    type: "SUCCESS_JEWELARY",
    payload: data,
  };
};
export const errorJewelary = (data) => {
  return {
    type: "ERROR_JEWELARY",
    payload: data,
  };
};

//Vehicles Action

export const requestVehicles = (data) => {
  return {
    type: "REQUEST_VEHICLES",
  };
};
export const successVehicles = (data) => {
  return {
    type: "SUCCESS_VEHICLES",
    payload: data,
  };
};
export const errorVehicles = (data) => {
  return {
    type: "ERROR_VEHICLES",
    payload: data,
  };
};

//Savings Action

export const requestSavings = (data) => {
  return {
    type: "REQUEST_SAVINGS",
  };
};
export const successSavings = (data) => {
  return {
    type: "SUCCESS_SAVINGS",
    payload: data,
  };
};
export const errorSavings = (data) => {
  return {
    type: "ERROR_SAVINGS",
    payload: data,
  };
};

//Checking Action

export const requestChecking = (data) => {
  return {
    type: "REQUEST_CHECKING",
  };
};
export const successChecking = (data) => {
  console.log(data, "data")
  return {
    type: "SUCCESS_CHECKING",
    payload: data,
  };
};
export const errorChecking = (data) => {
  return {
    type: "ERROR_CHECKING",
    payload: data,
  };
};

//Credit Action

export const requestCredit = (data) => {
  return {
    type: "REQUEST_CREDIT",
  };
};
export const successCredit = (data) => {
  return {
    type: "SUCCESS_CREDIT",
    payload: data,
  };
};
export const errorCredit = (data) => {
  return {
    type: "ERROR_CREDIT",
    payload: data,
  };
};

//Cash Action

export const requestCash = (data) => {
  return {
    type: "REQUEST_CASH",
  };
};
export const successCash = (data) => {
  return {
    type: "SUCCESS_CASH",
    payload: data,
  };
};
export const errorCash = (data) => {
  return {
    type: "ERROR_CASH",
    payload: data,
  };
};

//Tax Refund Action

export const requestTaxRefund = (data) => {
  return {
    type: "REQUEST_TAX_REFUND",
  };
};
export const successTaxRefund = (data) => {
  return {
    type: "SUCCESS_TAX_REFUND",
    payload: data,
  };
};
export const errorTaxRefund = (data) => {
  return {
    type: "ERROR_TAX_REFUND",
    payload: data,
  };
};

//Life Insurance Action

export const requestLifeInsurance = (data) => {
  return {
    type: "REQUEST_LIFE_INSURANCE",
  };
};
export const successLifeInsurance = (data) => {
  return {
    type: "SUCCESS_LIFE_INSURANCE",
    payload: data,
  };
};
export const errorLifeInsurance = (data) => {
  return {
    type: "ERROR_LIFE_INSURANCE",
    payload: data,
  };
};

//Stocks Action

export const requestStocks = (data) => {
  return {
    type: "REQUEST_STOCKS",
  };
};
export const successStocks = (data) => {
  return {
    type: "SUCCESS_STOCKS",
    payload: data,
  };
};
export const errorStocks = (data) => {
  return {
    type: "ERROR_STOCKS",
    payload: data,
  };
};

//Retirements Action

export const requestRetirements = (data) => {
  return {
    type: "REQUEST_RETIREMENTS",
  };
};
export const successRetirements = (data) => {
  return {
    type: "SUCCESS_RETIREMENTS",
    payload: data,
  };
};
export const errorRetirements = (data) => {
  return {
    type: "ERROR_RETIREMENTS",
    payload: data,
  };
};

//Profit Action

export const requestProfit = (data) => {
  return {
    type: "REQUEST_PROFIT",
  };
};
export const successProfit = (data) => {
  return {
    type: "SUCCESS_PROFIT",
    payload: data,
  };
};
export const errorProfit = (data) => {
  return {
    type: "ERROR_PROFIT",
    payload: data,
  };
};

//Accounts Action

export const requestAccounts = (data) => {
  return {
    type: "REQUEST_ACCOUNTS",
  };
};
export const successAccounts = (data) => {
  return {
    type: "SUCCESS_ACCOUNTS",
    payload: data,
  };
};
export const errorAccounts = (data) => {
  return {
    type: "ERROR_ACCOUNTS",
    payload: data,
  };
};

//Partnership Action

export const requestPartnership = (data) => {
  return {
    type: "REQUEST_PARTNERSHIP",
  };
};
export const successPartnership = (data) => {
  return {
    type: "SUCCESS_PARTNERSHIP",
    payload: data,
  };
};
export const errorPartnership = (data) => {
  return {
    type: "ERROR_PARTNERSHIP",
    payload: data,
  };
};

//Other Assets Action

export const requestOtherAssets = (data) => {
  return {
    type: "REQUEST_OTHER_ASSETS",
  };
};
export const successOtherAssets = (data) => {
  return {
    type: "SUCCESS_OTHER_ASSETS",
    payload: data,
  };
};
export const errorOtherAssets = (data) => {
  return {
    type: "ERROR_OTHER_ASSETS",
    payload: data,
  };
};

//Continuation Assets Action

export const requestContinuationAssets = (data) => {
  return {
    type: "REQUEST_CONTINUATION_ASSETS",
  };
};
export const successContinuationAssets = (data) => {
  return {
    type: "SUCCESS_CONTINUATION_ASSETS",
    payload: data,
  };
};
export const errorContinuationAssets = (data) => {
  return {
    type: "ERROR_CONTINUATION_ASSETS",
    payload: data,
  };
};



//Get Data from 1 to 18 Questions

export const successDescriptionOptionsData = () => {
  return (dispatch) => {
    API.get(`/form_160_assets/get-asset-brief-description`).then((res) => {
      let data = res.data;
      dispatch(successGetCommunityProperty(data));
    });
  };
};

//Actions

export const requestGetCommunityProperty = (data) => {
  return {
    type: "REQUEST_GET_COMMUNITY_PROPERTY",
  };
};
export const successGetCommunityProperty = (data) => {
  return {
    type: "SUCCESS_GET_COMMUNITY_PROPERTY",
    payload: data,
  };
};
export const errorGetCommunityProperty = (data) => {
  return {
    type: "ERROR_GET_COMMUNITY_PROPERTY",
    payload: data,
  };
};



//Post Data from 18 to 26 Questions

export const postSecondTableData = (data) => {
  return (dispatch) => {
    API.put(`/debts/add-and-update-debts`, data).then((res) => {
      let dataPost = res.data;
      if (dataPost.data[0].asset_brief_description_id == 18) {
        dispatch(successStudentLoans(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 19) {
        dispatch(successTaxes(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 20) {
        dispatch(successSupport(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 21) {
        dispatch(successLoans(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 22) {
        dispatch(successCreditCards(dataPost));
      }
      else if (dataPost.data[0].asset_brief_description_id == 23) {
        dispatch(successDebts(dataPost));
      }

    });
  };
};

//Actions

export const requestpostSecondTableCommunityProperty = (data) => {
  return {
    type: "REQUEST_POST_SECOND_TABLE_COMMUNITY_PROPERTY",
  };
};
export const successpostSecondTableCommunityProperty = (data) => {
  return {
    type: "SUCCESS_POST_SECOND_TABLE_COMMUNITY_PROPERTY",
    payload: data,
  };
};
export const errorpostSecondTableCommunityProperty = (data) => {
  return {
    type: "ERROR_POST_SECOND_TABLE_COMMUNITY_PROPERTY",
    payload: data,
  };
};

//Student Loans Actions

export const requestStudentLoans = (data) => {
  return {
    type: "REQUEST_STUDENT_LOANS",
  };
};
export const successStudentLoans = (data) => {
  return {
    type: "SUCCESS_STUDENT_LOANS",
    payload: data,
  };
};
export const errorStudentLoans = (data) => {
  return {
    type: "ERROR_STUDEBT_LOANS",
    payload: data,
  };
};

//Taxes Actions

export const requestTaxes = (data) => {
  return {
    type: "REQUEST_TAXES",
  };
};
export const successTaxes = (data) => {
  return {
    type: "SUCCESS_TAXES",
    payload: data,
  };
};
export const errorTaxes = (data) => {
  return {
    type: "ERROR_TAXES",
    payload: data,
  };
};

//Support Actions

export const requestSupport = (data) => {
  return {
    type: "REQUEST_SUPPORT",
  };
};
export const successSupport = (data) => {
  return {
    type: "SUCCESS_SUPPORT",
    payload: data,
  };
};
export const errorSupport = (data) => {
  return {
    type: "ERROR_SUPPORT",
    payload: data,
  };
};

//Loans Actions

export const requestLoans = (data) => {
  return {
    type: "REQUEST_LOANS",
  };
};
export const successLoans = (data) => {
  return {
    type: "SUCCESS_LOANS",
    payload: data,
  };
};
export const errorLoans = (data) => {
  return {
    type: "ERROR_LOANS",
    payload: data,
  };
};

//Credit Cards Actions

export const requestCreditCards = (data) => {
  return {
    type: "REQUEST_CREDIT_CARDS",
  };
};
export const successCreditCards = (data) => {
  return {
    type: "SUCCESS_CREDIT_CARDS",
    payload: data,
  };
};
export const errorCreditCards = (data) => {
  return {
    type: "ERROR_CREDIT_CARDS",
    payload: data,
  };
};

//Debts Actions

export const requestDebts = (data) => {
  return {
    type: "REQUEST_DEBTS",
  };
};
export const successDebts = (data) => {
  return {
    type: "SUCCESS_DEBTS",
    payload: data,
  };
};
export const errorDebts = (data) => {
  return {
    type: "ERROR_DEBTS",
    payload: data,
  };
};

//Continuation Debts Actions

export const requestContinuationDebts = (data) => {
  return {
    type: "REQUEST_CONTINUATION_DEBTS",
  };
};
export const successContinuationDebts = (data) => {
  return {
    type: "SUCCESS_CONTINUATION_DEBTS",
    payload: data,
  };
};
export const errorContinuationDebts = (data) => {
  return {
    type: "ERROR_CONTINUATION_DEBTS",
    payload: data,
  };
};


// Get Data
export const getData = (data) => {
  return (dispatch) => {
    dispatch(requestGetData(data));
    API.post(`/form_160_assets/get-all-data`, data).then((res) => {
      let data = res.data;
      dispatch(successGetData(data));
    });
  };
};

//Actions

export const requestGetData = (data) => {
  return {
    type: "REQUEST_GET_DATA",
  };
};
export const successGetData = (data) => {
  return {
    type: "SUCCESS_GET_DATA",
    payload: data,
  };
};
export const errorGetData = (data) => {
  return {
    type: "ERROR_GET_DATA",
    payload: data,
  };
};

//Delete Call

export const requestDeleteCommunityAssets = (data) => {
  return {
    type: "REQUEST_DELETE_COMMUNITY_ASSETS",
  };
};
export const successDeleteCommunityAssets = (data) => {
  return {
    type: "SUCCESS_DELETE_COMMUNITY_ASSETS",
    payload: data,
  };
};
export const errorDeleteCommunityAssets = (data) => {
  return {
    type: "ERROR_DELETE_COMMUNITY_ASSETS",
    payload: data,
  };
};

export const  deleteCommunityAssetsCall = (data) => {
  return (dispatch) => {
    API.post(`/form_160_assets/delete-160-form-assets`,data).then((res) => {
      dispatch(successDeleteCommunityAssets(res.data));
    });
  };
};

// Delete call debits

export const requestDeleteCommunityDebits = (data) => {
  return {
    type: "REQUEST_DELETE_COMMUNITY_DEBITS",
  };
};
export const successDeleteCommunityDebits = (data) => {
  return {
    type: "SUCCESS_DELETE_COMMUNITY_DEBITS",
    payload: data,
  };
};
export const errorDeleteCommunityDebits = (data) => {
  return {
    type: "ERROR_DELETE_COMMUNITY_DEBITS",
    payload: data,
  };
};

export const  deleteCommunityDebitsCall = (data) => {
  return (dispatch) => {
    API.post(`/debts/delete-160-form-debts`,data).then((res) => {
      dispatch(successDeleteCommunityDebits(res.data));
    });
  };
};


